import PromModel from '@/models/Prom';

const GET_COUPON_PROD_PAGING_LIST = 'GET_COUPON_PROD_PAGING_LIST';

/**
 * 获取优惠券适用商品列表(分页)
 */
async function getCouponProdPagingList(params) {
  const payload = await new PromModel().couponProdPagingList(params);
  return {
    type: GET_COUPON_PROD_PAGING_LIST,
    payload
  }
}

const ACTION_TYPES = {
  GET_COUPON_PROD_PAGING_LIST,
};

const ACTION = {
  getCouponProdPagingList,
};

const CouponProdList = {
  ACTION_TYPES,
  ACTION
}

export default CouponProdList;